<template>
  <div class="hvf-image-view interactive-canvas-wrapper" 
    :id="wrapperId"
    ref="wrapper"
    tabindex="0"
    @mousedown.self.left.prevent="handleMousedown"
    @mousemove.self.prevent="handleMousemove"
    @mouseup.self.left.prevent="handleMouseup"
    @mouseout.self.prevent="handleMouseout"
    v-hammer:panstart="handlePanstart"
    v-hammer:pan="handlePanmove"
    v-hammer:panend="handlePanend">
    <image-not-found v-if="imgNotFound" />
    <canvas-image
      :img="img"
      :canvasSize="canvasSize"
      :imgSize="imgSize"
      :transform="transform"
      :hires="true" />
    <v-progress-circular v-if="imgIsLoading" class="escalon-absolute-center" indeterminate/>
  </div>
</template>

<script>
import canvasImage from "../../../canvas/components/CanvasImage"
import touchMouseEvents from "../../mixins/TouchMouseEvents";
import imageNotFound from "../../misc/ImageNotFound";
import { defaultTransform, setOffsets, bound, minCenterY, centerYFromScroll, defaultSize, setTransformSizes } from "../../../canvas/geometry";
import { mapWatchers } from "../../../helpers/utils";
export default {
  name: "hvfImageView",
  mixins: [touchMouseEvents],
  components: {canvasImage, imageNotFound},
  props: ["eye", "image", "canvasSize", "index", "scroll"],
  data(){
    return {
      transform: defaultTransform(),
    }
  },
  computed: {
    wrapperId() {
      return "hvf-image-view-" + this.eye + (this.index || "");
    },
    imgIsLoading() {
      return this.image && (this.image.imgIsLoading || this.image.imgIsQueued);
    },
    imgNotFound() {
      return !!(this.image && this.image.imgNotFound);
    },
    img() {
      return this.image && this.image.imgHtmlObject;
    },
    imgSize() {
      return this.image && this.image.imgSize || defaultSize();
    },
    minCenter() {
      let center = minCenterY(this.canvasSize, this.imgSize, this.transform);
      return isNaN(center) ? 0.5 : center;
    },
    maxCenter() {
      return 1 - this.minCenter;
    }
  },
  methods: {
    updateTransform() {
      if (!this.imgSize.w || !this.imgSize.h || !this.canvasSize.w) return;

      this.transform.zoom = this.canvasSize.w / this.imgSize.w;
      let centerY = centerYFromScroll(this.scroll, this.canvasSize, this.imgSize, this.transform);
      this.transform.centerY = bound(centerY, this.minCenter, this.maxCenter);
      setTransformSizes(this.transform, this.canvasSize, this.imgSize);
      setOffsets(this.transform);
    },
    handleInteractionStart(e){
      this.$refs.wrapper.focus();
      this.$emit("hvf_mousedown", {e, transform: this.transform, imgSize: this.imgSize});
    },
    handleInteractionMove(e){
      this.$emit("hvf_mousemove", {e, transform: this.transform, imgSize: this.imgSize});
    },
    handleInteractionStop(e){
      this.$emit("hvf_mouseup", e);
    }
  },
  watch: {
    ...mapWatchers(["img", "imgSize", "canvasSize", "scroll"], function(){
      this.updateTransform();
    }, true)
  },
  mounted(){
    this.updateTransform();
  }
};
</script>